import { gql } from '@apollo/client';

//Revenue
const queryRevenue = gql`
  query Revenue($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    invoices(currency: $currency, freq: $freq) {
      amount
      currency
      project
      period
    }
  }
`;

//Revenue by category (Revenue children )
const queryRevenueByCategory = gql`
  query RevenueByCategory($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    invoices(currency: $currency, freq: $freq, byCategory: true) {
      amount
      currency
      project
      period
      title
    }
  }
`;

//Other Income
const queryOtherIncome = gql`
  query OtherIncome($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    extraIncome(currency: $currency, freq: $freq, byCategory: false) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Other Income by category (Other Income children )
const queryOtherIncomeByCategory = gql`
  query OtherIncomeByCategory($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    extraIncome(currency: $currency, freq: $freq, byCategory: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Direct costs
const queryDirectCosts = gql`
  query DirectCosts($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    directCosts(currency: $currency, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Salaries of assigned employees
const querySalariesAssignedEmployees = gql`
  query SalariesAssignedEmployees($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, freq: $freq, subCategory: ASSIGNED) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Project expenses
const queryProjectExpenses = gql`
  query ProjectExpenses($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    directCosts(currency: $currency, freq: $freq, subCategory: PROJECT) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Gross Income
const queryGrossIncome = gql`
  query GrossIncome($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    grossIncome(currency: $currency, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Indirect Costs
const queryIndirectCosts = gql`
  query IndirectCosts($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    indirectCosts(currency: $currency, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Administrative personnel
const queryAdministrativePersonnel = gql`
  query AdministrativePersonnel($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, freq: $freq, subCategory: ADMIN) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Employees on bench
const queryEmployeesOnBench = gql`
  query EmployeesOnBench($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, freq: $freq, subCategory: NOT_ASSIGNED) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Expenses
const queryExpenses = gql`
  query Expenses($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(currency: $currency, freq: $freq, reasonType: OPERATIONAL, excludeProject: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Expenses by category (Expenses children )
const queryExpensesByCategory = gql`
  query ExpensesByCategory($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(currency: $currency, freq: $freq, byCategory: true, reasonType: OPERATIONAL, excludeProject: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Net Income
const queryNetIncome = gql`
  query NetIncome($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    netIncome(currency: $currency, freq: $freq) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//By project scenario
//Revenue by project
const queryRevenueByProject = gql`
  query RevenueByProject($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    invoices(currency: $currency, freq: $freq, byProject: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Revenue by project by category
const queryRevenueByPC = gql`
  query RevenueByPC($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    invoices(currency: $currency, freq: $freq, byProject: true, byCategory: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Direct costs by project
const queryDirectCostsByProject = gql`
  query DirectCostsByProject($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    directCosts(currency: $currency, freq: $freq, byProject: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Salaries by project
const querySalariesByProject = gql`
  query SalariesByProject($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, freq: $freq, byProject: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Salaries by project and employee
const querySalariesBPE = gql`
  query SalariesBPE($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    salaries(currency: $currency, freq: $freq, byProject: true, byEmployee: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Expenses by project
const queryExpensesByProject = gql`
  query ExpensesByProject($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(currency: $currency, freq: $freq, byProject: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Expenses by project
const queryExpensesBPC = gql`
  query ExpensesBPC($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    expenses(currency: $currency, freq: $freq, byProject: true, byCategory: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

//Gross Income by project
const queryGrossIncomeByProject = gql`
  query GrossIncomeByProject($freq: FrequencyEnum, $currency: CurrencyEnum) @api(name: reporting) {
    grossIncome(currency: $currency, freq: $freq, byProject: true) {
      title
      amount
      currency
      project
      period
    }
  }
`;

export {
  queryRevenue,
  queryRevenueByCategory,
  queryOtherIncome,
  queryOtherIncomeByCategory,
  queryDirectCosts,
  querySalariesAssignedEmployees,
  queryProjectExpenses,
  queryGrossIncome,
  queryIndirectCosts,
  queryAdministrativePersonnel,
  queryEmployeesOnBench,
  queryExpenses,
  queryExpensesByCategory,
  queryNetIncome,
  queryRevenueByProject,
  queryRevenueByPC,
  queryDirectCostsByProject,
  querySalariesByProject,
  querySalariesBPE,
  queryExpensesByProject,
  queryExpensesBPC,
  queryGrossIncomeByProject,
};
